export default {
  id: null,
  nome: null,
  botId: null,
  dataCriacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/registrobotmodel.js